// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__D7gBr","list":"PatternAutocomplete_list__17zPi"};